import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
 
@Component({
  selector: 'app-modals-reject',
  templateUrl: './modals-reject.component.html',
  styleUrls: ['./modals-reject.component.css']
})
export class ModalsRejectComponent {
  isApproved: boolean;
  observation: string = null;
  constructor(public dialogRef: MatDialogRef<ModalsRejectComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService) {
  }
  onSubmit() {
    this.isApproved = false;
    const policy = {
      policyId: this.data.sendData.policyId,
      statusId: 3,
    };
    if (this.observation === '' || this.observation === undefined  || this.observation === null) {
      this.observation = null;
    } else {
      Object.assign(policy, {observation: this.observation});
    }
    this.dialogRef.close(policy);
    return;
  }
}